module.exports = __webpack_public_path__ + "media/Loops 110 Perc.bb5cc76e.wav";